import classNames from 'classnames';

import {useI18n} from '@udemy/i18n';

import styles from './outline-pill.module.less';

interface OutlinePillProps {
    title: string;
    isFilled?: boolean;
    filledBackground?: string;
    /** Unfilled background, typically the catalog section color (`color.light`). */
    backgroundColor?: string;
    /**
     * When true, shows a nested "Trending" tag on the right side of the pill.
     */
    showTrendingTag?: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const OutlinePill = ({
    title,
    isFilled = false,
    filledBackground,
    backgroundColor,
    showTrendingTag = false,
    onClick,
}: OutlinePillProps) => {
    const {gettext} = useI18n();
    const style = isFilled
        ? {backgroundColor: filledBackground, borderColor: filledBackground}
        : backgroundColor
          ? {backgroundColor}
          : {};
    return (
        <button
            type="button"
            aria-pressed={isFilled}
            onClick={onClick}
            className={classNames(
                styles['outline-pill'],
                isFilled && styles['outline-pill-filled'],
            )}
            style={style}
            data-purpose="outline-pill"
        >
            <span className={styles['outline-pill-title']}>{title}</span>
            {showTrendingTag && (
                <span className={styles['outline-pill-trending']}>{gettext('Trending')}</span>
            )}
        </button>
    );
};
